export default class ParallaxElements {
	constructor() {
		let parallaxElements = document.querySelectorAll(
			"*[data-parallax-background-image-url]"
		);

		if (parallaxElements.length > 0) {
			parallaxElements.forEach((el) => {
				let parallaxElement = el;
				let parallaxImageUrl = parallaxElement.getAttribute(
					"data-parallax-background-image-url"
				);

				if (parallaxImageUrl) {
					parallaxElement.style.backgroundImage = `url('${parallaxImageUrl}')`;
				}
			});
		}
	}
}
